import ObjectID from 'bson-objectid';
import { z } from 'zod';

const objectIdSchema = z.string();
const isValidObjectIdSchema = z.string().refine((item) => ObjectID.isValid(item));
const isValidDateSchema = z.string().datetime().optional();

export { isValidDateSchema, isValidObjectIdSchema, objectIdSchema };
